import { backendApi } from '@/lib/api/client';
import { endpoints } from '@/lib/api/endpoints';
import type { MaintenanceStatus } from '../types/maintenance.types';

/**
 * The website lets this answer be cached for 30 s, but the hosting cache in
 * front of www.gralmedical.ro rewrites every 200 response to max-age=86400 and
 * ignores the origin's Cache-Control; the browser then honours those 24 h too.
 * A query value that changes every 30 s keys each window to its own cache entry
 * (shared by all users), so a maintenance window is seen within 30 s instead of
 * hours, without bypassing the cache on every poll.
 */
const CACHE_WINDOW_MS = 30_000;

/**
 * Public (unauthenticated) maintenance status for Contul meu. The path is in
 * the client's PUBLIC_PATHS list, so no Bearer token is attached and a failure
 * never triggers the token-refresh path.
 */
export async function fetchMaintenanceStatus(): Promise<MaintenanceStatus> {
  const { data } = await backendApi.get<MaintenanceStatus>(endpoints.backend.maintenance, {
    params: { t: Math.floor(Date.now() / CACHE_WINDOW_MS) },
    // Short timeout: this call gates the UI, it must never hang the app.
    timeout: 10_000,
  });
  return data;
}
